import React from 'react';
import explore_1 from '../images/explora_1.jpg';
import explore_2 from '../images/explora_2.webp';
import explore_3 from '../images/explora_3.jpg';
import explore_4 from '../images/explora_4.jpg';
import explore_5 from '../images/explora_5.jpg';
import anuncio_1 from '../images/anuncio_1.jpg';
import anuncio_2 from '../images/anuncio_2.jpg';
import anuncio_3 from '../images/anuncio_3.jpg';

export const Menu_derecha_home = () => {
    const exploreData = [
        { src: explore_1, text: 'Animales' },
        { src: explore_2, text: 'Belleza' },
        { src: explore_3, text: 'Manualidades' },
        { src: explore_4, text: 'Hogar' },
        { src: explore_5, text: 'Comida' },
      ];

  return (
    <div className='content-menu-home'>
        <div className='explore'>
            <div className='title-menu-home'>
            <h2>Explora</h2>
            </div>
            {exploreData.map((item, index) => (
            <div className='card-explore' key={index}>
                <img src={item.src} alt="explore" />
                <div className='overlay-explore'>
                <span>{item.text}</span>
                </div>
            </div>
            ))}
        </div>
        <div className='advertising' style={{marginTop:'1.5rem'}}>
            <div className='title-menu-home'>
                <h2>Publicidad</h2>
            </div>
            <div className='advertising-two-images'>
                <img src={anuncio_1} alt="anuncio" />
                <img src={anuncio_2} alt="anuncio" />
            </div>
            <div className='advertising-one-images'>
                <img src={anuncio_3} alt="anuncio" />
            </div>

        </div>
    </div>
  )
}
